import { useCities } from '../api/locationsApi'
import { useParticipantProfile } from '../api/participantProfileApi'
import { isOtherCity } from './cityName'

/**
 * Город профиля участника — «Другое»? Связка профиль → справочник страны →
 * `isOtherCity` в одном месте для плашки, окна при входе и окна перед записью.
 * Пока профиль или справочник не пришли, `isOther` — `false`, а `profile` —
 * `undefined` до первого ответа: никто не показывает окно раньше данных.
 */
export function useProfileCityIsOther() {
  const { data: profile } = useParticipantProfile()
  const { data: cities } = useCities(profile?.country ?? undefined)
  return { profile, isOther: isOtherCity(profile, cities) }
}
